(function ($, Drupal) {
  Drupal.behaviors.playVideoIcon = {
    attach(context, settings) {
      if (document.getElementsByClassName('video-icon').length) {
        var playIcon = document.getElementsByClassName('video-icon')
        for (var i = 0; i < playIcon.length; i++) {
          if (document.getElementsByClassName('video-icon-money').length) {
            new Waypoint({
              element: document.getElementById('video-icon-money'),
              handler: function () {
                $('.card--E video').get(0).play();
              },
              offset: 'bottom-in-view'
            })
          }
          if (document.getElementsByClassName('video-icon-earth').length) {
            new Waypoint({
              element: document.getElementById('video-icon-earth'),
              handler: function () {
                $('.card--E video').get(1).play();
              },
              offset: 'bottom-in-view'
            })
          }
          if (document.getElementsByClassName('video-icon-health').length) {
            new Waypoint({
              element: document.getElementById('video-icon-health'),
              handler: function () {
                $('.card--E video').get(2).play();
              },
              offset: 'bottom-in-view'
            });
          }
        }
      }
    }
  };
}(jQuery, Drupal));
